export default __webpack_public_path__ + "static/media/amy-winehouse.c6503ff9.jpg";